<template>
    <customModal :containerxl="true" @closeModal="$emit('closeModal')">

        <template #title>
            Mitigation Details
        </template>

        <template #body>

            <div class="modal-content-wrapper">

                <!-- BASIC INFORMATION -->
                <div class="section-block">
                    <h6 class="mb-1 border-bottom pb-1">
                        Basic Information
                    </h6>

                    <div class="row">

                        <!-- LEFT -->
                        <div class="col-md-6">
                            <div class="d-flex border-bottom py-1">
                                <div class="label-block"><strong>CTQ ID</strong></div>
                                <div>{{ data.ctqId || "-" }}</div>
                            </div>

                            <div class="d-flex border-bottom py-1">
                                <div class="label-block"><strong>Mitigation ID</strong></div>
                                <div>{{ data.mitigationId || "-" }}</div>
                            </div>

                            <div class="d-flex border-bottom py-1">
                                <div class="label-block"><strong>Risk ID</strong></div>
                                <div>{{ data.riskId || "-" }}</div>
                            </div>
                            <div class="d-flex border-bottom py-1">
                                <div class="label-block"><strong>KRI ID</strong></div>
                                <div>{{ data.kriId || "-" }}</div>
                            </div>
                        </div>

                        <!-- RIGHT -->
                        <div class="col-md-6">
                            <div class="d-flex border-bottom py-1">
                                <div class="label-block"><strong>Action Owner</strong></div>
                                <div>{{ data.actionOwner || "-" }}</div>
                            </div>

                            <div class="d-flex border-bottom py-1">
                                <div class="label-block"><strong>Monitoring Frequency</strong></div>
                                <div>{{ data.monitoringFrequency || "-" }}</div>
                            </div>

                            <div class="d-flex border-bottom py-1">
                                <div class="label-block"><strong>Target Completion</strong></div>
                                <div>{{ data.targetCompletionDate || "-" }}</div>
                            </div>

                            <div class="d-flex border-bottom py-1">
                                <div class="label-block"><strong>Status</strong></div>
                                <div>{{ data.isActive ? "Active" : "Inactive" }}</div>
                            </div>
                        </div>

                    </div>

                </div>

                <!-- RISK DESCRIPTION -->
                <div class="section-block mt-4">
                    <h6 class="mb-1">Risk Description</h6>
                    <div class="border rounded p-3 bg-light">
                        {{ data.riskDescription || "-" }}
                    </div>
                </div>

                <!-- MITIGATION STRATEGY -->
                <div class="section-block mt-4">
                    <h6 class="mb-1">Mitigation Strategy</h6>
                    <div class="border rounded p-3 bg-light">
                        {{ data.mitigationStrategy || "-" }}
                    </div>
                </div>

                <!-- CONTINGENCY PLAN -->
                <div class="section-block mt-4">
                    <h6 class="mb-1">Contingency Plan</h6>
                    <div class="border rounded p-3 bg-light">
                        {{ data.contingencyPlan || "-" }}
                    </div>
                </div>

                <!-- EVIDENCE OF IMPLEMENTATION -->
                <div class="section-block mt-4">
                    <h6 class="mb-1">Evidence of Implementation</h6>
                    <div class="border rounded p-3 bg-light">
                        {{ data.evidenceOfImplementation || "-" }}
                    </div>
                </div>

            </div>

        </template>

    </customModal>
</template>

<script src="./Mitigationdetailsmodal.js"></script>

<style scoped>
.section-block h6 {
    font-size: .9rem !important;
    font-weight: 600 !important;
    margin-bottom: 4px;
    color: #3d4b63;
}

.label-block {
    min-width: 180px;
}

.modal-content-wrapper {
    max-height: 75vh;
    overflow-y: auto;
    padding-right: 4px;
}
.ibox-title{
  padding: 8px 15px 8px 15px !important;
  min-height: 34px;  
}
</style>